import { render, staticRenderFns } from "./Black.vue?vue&type=template&id=2ca4abbc&"
import script from "./Black.vue?vue&type=script&lang=ts&"
export * from "./Black.vue?vue&type=script&lang=ts&"
import style0 from "./Black.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports